module.exports = __webpack_public_path__ + "img/382.268aebd6.png";